import React from 'react';
import { motion } from 'framer-motion';
import './EntrenamientoPersonal.css';

export default function EntrenamientoPersonal() {
  const objetivos = [
    "Pérdida importante de peso",
    "Tratamiento de patologías crónicas",
    "Preparación de pruebas específicas",
    "Entre otros"
  ];

  const tarifas = [
    {
      key: 'uno',
      title: 'UNO',
      price: 280,
      desc: 'pensada para entrenamiento personal 1 a 1',
      features: [
        "Valoraciones funcionales",
        "Horarios adaptables",
        "2 sesiones a la semana",
        "1 persona máximo"
      ]
    },
    {
      key: 'duo',
      title: 'DUO',
      price: 195,
      desc: 'pensada para personas que quieran venir en pareja',
      features: [
        "Valoraciones funcionales",
        "Horarios adaptables",
        "2 sesiones a la semana",
        "2 personas máximo"
      ]
    },
    {
      key: 'trio',
      title: 'TRIO',
      price: 120,
      desc: 'pensada para personas que quieran venir en trío',
      features: [
        "Valoraciones funcionales",
        "Horarios adaptables",
        "3 sesiones a la semana",
        "3 personas máximo"
      ]
    }
  ];

  return (
    <div className="personal-container">
      <motion.h1
        className="personal-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        ENTRENAMIENTO <span className="accent">PERSONAL</span>
      </motion.h1>

      <motion.p
        className="personal-description"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        Dirigido a personas que busquen conseguir unos objetivos concretos a través de una planificación individual adaptada y personalizada.
      </motion.p>

      <motion.div
        className="personal-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        <h2>Ejemplos de objetivos</h2>
        <ul className="personal-list">
          {objetivos.map((o, i) => <li key={i}>{o}</li>)}
        </ul>
      </motion.div>

      <motion.div
        className="personal-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <h2>Precios</h2>
        <div className="personal-precios">
          {tarifas.map(plan => (
            <div key={plan.key} className={`personal-precio-cell ${plan.key}`}>
              <h3 className="personal-precio-title">
                Tarifa <span className="accent">{plan.title}</span>
              </h3>
              <div className="personal-price-pill">{plan.price} €</div>
              <p className="personal-descripcion">{plan.desc}</p>
              <ul className="personal-features">
                {plan.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="personal-note">Precios por persona y mes.</p>
      </motion.div>

      <motion.div
        className="personal-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Algunas observaciones</h2>
        <p>– las reservas se realizarán de forma online a través de una aplicación móvil en los horarios pre-establecidos.</p>
        <p>– los entrenamientos son supervisados por profesionales graduados en CAFYD con la cualificación necesaria para adaptar los trabajos a tu situación individual.</p>
      </motion.div>
    </div>
  );
}
